import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/gymklar';
const recap = ['6 bind', '5 bonuser', '240 sider', 'Nybegynner → maraton'];
const reassurances = ['Direkte nedlasting', 'PDF klar til utskrift', '7 dager pengene-tilbake-garanti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-101" data-mp="15fgj2o0dj92i">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-102" data-mp="1jb23ehvnx4ol" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-103" data-mp="1t2omf0e8s81w">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-104" data-mp="1t2525d14d7kp">
          Løpeåret ditt kan være <em className="text-red-700" data-id="element-105" data-mp="223mi8vej199e">klart allerede i dag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-106" data-mp="221jtsft0vo6s">
          I stedet for å lete etter økter, lage hver fellestrening selv og bruke søndagskvelden
          på planlegging, har du et ferdig system for hele sesongen. Mer tid til det som
          virkelig betyr noe:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-107" data-mp="x3s5ud5kay3k">
          Løperne dine. Øktene dine. Livet ditt utenfor løypa.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-108" data-mp="1246ik8i3yw7x">
          {recap.map(item => <li key={item} data-id="element-109" data-mp="1b3a0va9gb7ld">{item}</li>)}
        </ul>

        <p className="mt-8 text-base text-slate-900/60" data-id="element-110" data-mp="1b1yvx749rtso">
          Før <s className="decoration-red-700 decoration-2" data-id="element-111" data-mp="1ftqfuysx719u">{PRICE_BEFORE}</s>
        </p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-112" data-mp="1kt3cucdi9oq5">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-113" data-mp="1pszdc1mzuy0y">Engangsbetaling – ingen abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-114" data-mp="1ttjbn8jb07oo">
          <CtaButton className="w-full sm:w-auto" data-id="element-115" data-mp="1tuawbobd4l06" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-116" data-mp="3qvqkbxden6my">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-117" data-mp="3lxf85fzn0k1k">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-118" data-mp="3imtwdm2wxca" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}